// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultImageID: 'image_candle.jpg',
  firebaseConfig: {
    apiKey: 'AIzaSyD36PT8p9On73heW7tFiPu2UMCh4U4eOJk',
    authDomain: 'condoleance-register-marjoke.firebaseapp.com',
    databaseURL: 'https://condoleance-register-marjoke.firebaseio.com',
    projectId: 'condoleance-register-marjoke',
    storageBucket: 'condoleance-register-marjoke.appspot.com',
    messagingSenderId: '116530468910',
    appId: '1:116530468910:web:f3c9df9dae0eefd42327bf',
    measurementId: 'G-Q3VZG7QN6Y'
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
